import { render, staticRenderFns } from "./BaseSpan.vue?vue&type=template&id=762f85e4&scoped=true&"
import script from "./BaseSpan.vue?vue&type=script&lang=js&"
export * from "./BaseSpan.vue?vue&type=script&lang=js&"
import style0 from "./BaseSpan.vue?vue&type=style&index=0&id=762f85e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762f85e4",
  null
  
)

export default component.exports